import * as HighCharts from 'highcharts/highstock'; // tslint:disable-line
import { Component } from 'react';
class LinearChart extends Component<any> {
  private chart: any;
  public componentDidMount() {
    this.loadChart();
  }
  public loadChart() {
    const { graphData, categoryData, graphConfig, category } = this.props;

    this.chart = new HighCharts.StockChart('chart-container', {
      ...graphConfig,
      navigator: {
        enabled: false,
      },
      scrollbar: {
        enabled: false,
      },
      rangeSelector: {
        inputEnabled: false,
        buttons: [
          { type: 'month', count: 1, text: '1M' },
          { type: 'month', count: 3, text: '3M' },
          { type: 'month', count: 6, text: '6M' },
          { type: 'year', count: 1, text: '1Y' },
          { type: 'year', count: 3, text: '3Y' },
          { type: 'year', count: 5, text: '5Y' },
          { type: 'all', text: 'Max' },
        ],
        selected: 4,
        labelStyle: {
          display: 'none',
        },
      },
      credits: {
        enabled: false,
      },
      yAxis: {
        labels: {
          enabled: false,
        },
        gridLineWidth: 0,
        title: {
          text: null,
        },
      },
      series: [
        {
          name: 'Fund',
          data: graphData || [],
          tooltip: {
            valueDecimals: 2,
          },
        },
        {
          name: category,
          data: categoryData || [],
          tooltip: {
            valueDecimals: 2,
          },
          visible: false,
        },
      ],
    });
  }

  public componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  public render() {
    return (
      <div
        id="chart-container"
        style={{
          minWidth: 310,
          height: 400,
          margin: '0 auto',
        }}
      />
    );
  }
}

export default LinearChart;



// WEBPACK FOOTER //
// ./components/singleFund/LinearChart.tsx